<template>
  <div>
    <button type="button" class="btn btn-primary btn-outline-2 btn-fb" @click="logInWithFacebook">
      <span v-show="!loading">
        Entrar com Facebook
      </span>
      <span class="loader" v-if="loading">
        <i class="fa fa-spin fa-spinner"></i>
      </span>
    </button>
  </div>
</template>
<script>

export default {
  name: 'FacebookLogin',
  props: {
    loading: Boolean
  },
  created () {
    this.initFacebook()
  },
  methods: {
    async logInWithFacebook (event) {
      try {
        window.FB.login(response => {
          if (response.authResponse) {
            this.$emit('token', response.authResponse.accessToken)
          } else {
            alert('Usuário(a) cancelou o login ou não autorizou o aplicativo.')
          }
        }, { scope: 'email' })
      } catch (error) {
        console.log(error)
      }
    },
    async initFacebook () {
      await this.loadFacebookSDK(document, 'script', 'facebook-jssdk')
      await this.initSDK()
    },
    async initSDK () {
      window.fbAsyncInit = function () {
        window.FB.init({
          appId: process.env.VUE_APP_APP_FB_ID,
          autoLogAppEvents: true,
          xfbml: true,
          version: 'v13.0'
        })
      }
    },
    async loadFacebookSDK (d, s, id) {
      var js
      var fjs = d.getElementsByTagName(s)[0]
      if (d.getElementById(id)) {
        return
      }
      js = d.createElement(s)
      js.id = id
      js.src = 'https://connect.facebook.net/en_US/sdk.js'
      fjs.parentNode.insertBefore(js, fjs)
    }
  }
}
</script>
<style>
.loader {
  display: inline-block;
}
.btn-fb, .btn-fb:active, .btn-fb:focus{
  background: #3b5998 !important;
  border-color: #3b5998 !important;
  color: #fff !important;
}
.btn-fb:hover{
  background: #fff !important;
  border-color: #fff !important;
  color: #3b5998 !important;
}
</style>
